<template>
    <div>
        <title>后续分销操作记录</title>
        <article class="cardArticle">
            <header class="tabHeader">
                <p>
                  <router-link :to="{path:'/OperateRecord'}" v-if="openStoreDefinition==1">定义激活记录</router-link>
                  <router-link :to="{path:'/ActivationRecord'}" >激活记录</router-link>
                  <router-link :to="{path:'/PauseRecord'}"  >暂停记录</router-link>
                  <router-link :to="{path:'/ReuseRecord'}" >恢复记录</router-link>
                  <router-link :to="{path:'/RecoverRecord'}" class="isActive" v-if="ElementControls('erjimendian')==1">销售回收记录</router-link>
                  <router-link :to="{path:'/SpreadRecordMd'}" v-if="ElementControls('erjimendian')==1">铺券记录</router-link>
                </p>
            </header>
            <main class="cardMain">
                 <!--S 检索-->
                <el-form :model="searchRecordForm" inline class="searchForm operateForm">
                    <el-form-item label="关键词">
                        <el-input clearable v-model="searchRecordForm.keyword" placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="回收时间">
                        <el-date-picker v-model="searchRecordForm.outBoundDate" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                        </el-date-picker>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="query">查询</el-button>
                    </el-form-item>
                </el-form>
                <!-- E 检索 -->
                <section>
                    <el-table ref="gsTable" class="comTable recordTable" border v-loading="vloading" :data="cardBatchList" :maxHeight="tableHeight">
                        <el-table-column fixed label="序号" type="index" width="60"></el-table-column>
                        <el-table-column label="回收时间" fixed prop="operdate" min-width="200">
                            <template slot-scope="scope">
                               {{dateTime(scope.row.operdate,1)}}
                            </template>
                        </el-table-column>
                        <el-table-column label="总数" sortable prop="opernum" fixed min-width="130">
                            <template slot-scope="scope">
                                <router-link :to="{path:'RecoverRecordTotal',query:{batchcode:scope.row.batchcode}}" class="total priceFont"><i class="iconhand"></i>{{scope.row.opernum ||'0'}}</router-link>
                            </template>
                        </el-table-column>
                        <el-table-column label="序列号段" sortable prop="serials" min-width="180">
                          <template slot-scope="scope">
                                <!-- <p v-if="scope.row.serials!=null&&scope.row.serials.indexOf(',') != -1" class="serial">
                                    {{scope.row.serials.split(',')[0]}}
                                    <em>~</em>
                                    {{scope.row.serials.split(',')[1]}}
                                </p> -->
                                <p v-if="scope.row.serials!=null&&scope.row.serials.indexOf(',') == -1" class="serial">
                                    {{scope.row.serials.split('-')[0]}}
                                    <em>~</em>
                                    {{scope.row.serials.split('-')[1]}}
                                </p>
                                <div v-else-if="scope.row.serials!=null&&scope.row.serials.indexOf(',') != -1&&scope.row.serials.split(',').length>1" class="serialWrap">
                                    <el-popover placement="bottom" width="350" trigger="hover">
                                        <div class="serialPop">
                                            <ul class="flexAro">
                                                <li v-for="(item,index) in scope.row.serials.split(',')" :key="index">
                                                    {{item}}
                                                </li>
                                            </ul>
                                        </div>
                                        <a class="checkSerial"  slot="reference">查看序列号段</a>
                                    </el-popover>
                                </div>
                                <div v-else>--</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作人" sortable prop="operuname"  min-width="150">
                           <template slot-scope="scope">
                                {{scope.row.operuname ||'--'}}
                            </template>
                        </el-table-column>
                        <el-table-column label="批次记录来源"  min-width="150">
                          <template slot-scope="scope">
                              <p>门店销售回收</p>
                          </template>
                          </el-table-column>
                        <!--<el-table-column label="客服备注" >
                            <template slot-scope="scope">
                                <p class="textHiden" :title="scope.row.sermemo">{{scope.row.sermemo || '--'}}</p>
                            </template>
                        </el-table-column>-->
                        <el-table-column label="备注"  min-width="200">
                            <template slot-scope="scope">
                                <p class="textHiden" :title="scope.row.memo">{{scope.row.memo || '--'}}</p>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column label="操作"  width="90">
                            <template slot-scope="scope">
                                <a class="mainColor" @click="exports(scope.row)">导出</a>
                            </template>
                        </el-table-column> -->
                        <template slot="empty" v-if="vloading">
                          <div :class="{noData:vloading}"></div>
                        </template>
                        <template slot="empty" v-else>
                          <div class="noData"><span>暂无数据</span></div>
                        </template>
                    </el-table>
                    <!-- S 分页 -->
                    <Page :pageTotal="pageTotal" :currentPage="currentPage" :pageSize="pageSize" @nowPageParam="nowPageParam"></Page>
                    <!-- E 分页 -->
                </section>
            </main>
        </article>
    </div>
</template>
<script>
import Api from "@/apis/api.js";
import { mapState, mapActions } from "vuex";
export default {
    name:'OperateRecord',
    components: {
      Page: resolve => require(["@/components/common/Page.vue"], resolve),//分页
    },
    data(){
        return{
            openStoreDefinition:0,
			      vloading:false,
            types:0,
            batchcode:'',
            num:0,
            pageTotal:0, //总数
            currentPage:1, // 页数
            pageSize:30, // 条数
            cardBatchList:[],
            batchOtherOper:'',
            // 检索表单
            searchRecordForm:{
                keyword:'',//关键词
                outBoundDate:'', //出库日期
                flowcode:'',//内部流向
                membercode:'',//会员流向
            },
             //选择时间
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            highShow:false,//是否展示高级筛选
            recoverMemo:'',//操作类弹框备注
            recoverDialogVisible:false,//操作类弹框
            coverSuccessDialogVisible:false,//操作类成功弹框
            tableHeight: window.innerHeight*.8, //表格动态高度
            operateTxt:'',//弹框类型文字
            paths:'',
        }
    },
    // ==================================== 计算属性 ====================================
    computed: {
      ...mapState({
        bdis: ({ common }) => common.bdis,
      })
    },
    watch:{
      $route(to,from){
           this.paths = from.name
        },
    },
    activated(){
      setTimeout(()=>{
        if(this.paths=='券卡回收记录操作记录总数'){
          this.getCardBatchList();
        }else{
              this.pageTotal=0; //总数
              this.currentPage=1; // 页数
              this.pageSize=30; // 条数
              // 检索表单
              this.searchRecordForm={
                  keyword:'',//关键词
                  outBoundDate:'', //出库日期
                  flowcode:'',//内部流向
                  membercode:'',//会员流向
              };
              this.getCardBatchList();
        }
      },100)
    },
    // ==================================== 方法 ====================================
    methods:{
      exports(item){
        this.vloading = true
        Api.GET_URLFORCYCLECARDLIST({batchcode:item.batchcode,opertype:15,codetype:0,operdate:this.dateTime(item.operdate,1)}).then(res =>{
            if(res.data.status=="200"){
              this.vloading = false
               window.location.href = res.data.data;
            }else{
              this.vloading = false
              this.$message.error(res.data.message)
            }
        }).catch(()=>{
           this.vloading = false
        })
      },
        //查询
        query(){
          this.pageSize =30;
          this.currentPage =1;
          this.$refs.gsTable.bodyWrapper.scrollTop = 0;
          this.getCardBatchList();
        },
        // 分页
        nowPageParam(val,vals){
          this.pageSize = val;
          this.currentPage = vals;
          this.$refs.gsTable.bodyWrapper.scrollTop = 0;
          this.getCardBatchList();
        },
        //动态获取表格高度
        getHeight() {
        let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
        //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
        this.tableHeight = window.innerHeight - tbHeight - 125;
        },
        getCardBatchList(){
			this.vloading = true;
           let param = {
                codetype:0,
                opertype:15,
                cardmedium:0,
                startvaldate:this.searchRecordForm.outBoundDate?this.dateTime(this.searchRecordForm.outBoundDate[0]):'',
                endvaldate:this.searchRecordForm.outBoundDate?this.dateTime(this.searchRecordForm.outBoundDate[1]):'',
                keyword:this.searchRecordForm.keyword,
                flowcode:String(this.searchRecordForm.flowcode),
                membercode:this.searchRecordForm.membercode,
                pageparam:{
                    pagesize: this.pageSize, //每页条数
                    currentpage: this.currentPage, //当前页数
                }
           }
           Api.GET_CARDBATCHLIST(param).then(res =>{
               this.toTableTop('gsTable');
               if(res.data.status=="200"){
				 this.vloading = false;
                 this.cardBatchList = res.data.data;
                 this.pageTotal = res.data.pagebean.totalnum;
              }else {
                 this.pageTotal =0;
                 this.cardBatchList =[];
              }
           })
        },
    },
    // ==================================== 生命周期 ====================================
    mounted () {
      this.openStoreDefinition = this.ElementControls('openStoreDefinition');
        this.getCardBatchList();
        //在dom渲染之后
        setTimeout(()=>{
            this.getHeight();
        },200)

    },
    created() {
        //页面浏览器视窗变化绑定resize事件
        window.addEventListener("resize", this.getHeight);
    },
    destroyed(){
        window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    }
}
</script>
<style scoped>
.noData{
	height: 400px;
}
.cardArticle{
    position: relative;
    padding: 84px 20px 20px 20px;
    height: calc(100% - 169px);
}
/* S 检索 */
.simpleSearch{
    line-height: 40px;
    color: var(--main-color);
    cursor: pointer;
    white-space: nowrap;
}
.operateForm{
    margin-bottom: 10px;
}
.operateForm>>>.el-form-item{
    margin-bottom: 10px;
}
.none{
    display: none;
}
.block{
    display: block;
}
/* E 检索 */
/* S 表格 */
.total{
    line-height: 20px;
    font-weight: bold;
}
.total i{
    font-size: 20px;
    margin-right: 5px;
    vertical-align: text-bottom;
}
.serial em{
    display: block;
    margin-left: 26px;
}
.serialPop ul{
    -o-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    -moz-flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    max-height: 120px;
    overflow-y: auto;
}
.serialPop ul li{
    color: #666;
    line-height: 28px;
}
.recordTable .el-dropdown-link{
    cursor: pointer;
    color: var(--main-color);
}
.recordTable>>>.el-table__fixed-right-patch{
    background-color: #F5F7FA;
}
.recordTable>>>td:nth-child(5) .cell{
    overflow: initial;
}
.recoverBtn,
.pauseBtn{
    cursor: pointer;
}
.recoverBtn:hover,
.pauseBtn:hover{
    color:var(--main-color);
}
/* E 表格 */
/* S 回收弹框 */
.recoverDlog>>>.el-dialog{
    width: 420px;
}
.recoverDlog>>>.el-dialog__footer{
    box-shadow: none;
    margin-bottom: 5px;
}
.recoverDlog>>>.el-button{
    padding: 8px 15px;
}
.recoverDlog p{
    color: #666;
    line-height: 25px;
}
.recoverDlog>>>.el-dialog__body{
    padding: 13px 20px 11px 20px;
}
.recoverDlog>>>.el-textarea{
    margin-top: 15px;
}
.pink{
    color: #F7615E;
    font-weight: bold;
    margin: 0 5px;
}
.el-icon-warning{
    color: #F2962C;
    font-size: 24px;
    margin-right: 15px;
}
.coverSuccess p{
    margin-bottom: 5px;
}
.coverSuccess em{
    display: block;
    line-height: 1.5;
}
/* E 回收弹框 */
.left{text-align:left;}
</style>



// WEBPACK FOOTER //
// src/views/CardsFolder/CardsGift/CardRecord/RecoverRecord.vue